import {
    Component,
    inject,
    Input,
    OnChanges,
    SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DATE_FORMAT } from 'src/app/shared/constants';
import {
    DxButtonModule,
    DxDateBoxModule,
    DxFormModule,
    DxLoadPanelModule,
    DxRadioGroupModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxToolbarModule,
    DxValidationGroupModule,
    DxValidatorModule,
} from 'devextreme-angular';
import {
    IncidentReportDto,
    EmployeesClient,
    EmployeePositionDto,
} from '@services';
import { DxCheckBoxModule } from 'devextreme-angular/ui/check-box';
import { PicturedItemSelectBoxComponent } from '../../../../../../components';
import {CapitalCasePipe} from "../../../../../../pipes/capital-case.pipe";

@Component({
    selector: 'app-employee-incident-details',
    imports: [
        CommonModule,
        DxToolbarModule,
        DxButtonModule,
        DxLoadPanelModule,
        DxValidationGroupModule,
        DxTextBoxModule,
        DxValidatorModule,
        DxSelectBoxModule,
        DxDateBoxModule,
        DxScrollViewModule,
        DxFormModule,
        DxRadioGroupModule,
        DxTextAreaModule,
        DxCheckBoxModule,
        PicturedItemSelectBoxComponent,
        CapitalCasePipe,
    ],
    templateUrl: './employee-incident-details.component.html',
})
export class EmployeeIncidentDetailsComponent implements OnChanges {
    @Input() incidentReport: IncidentReportDto;
    @Input() selectedEmployeeId: any;
    @Input() employeesDataSource: any;
    @Input() shiftDataSource: any;
    @Input() isReadOnly: boolean = false;
    @Input() yesOrNoOptions: any;
    @Input() validateYesNo: (args: any) => boolean = () => true;

    public dateFormat = DATE_FORMAT;
    private employeesClient = inject(EmployeesClient);
    protected isNotEmployee: boolean = false;

    employeePosition: EmployeePositionDto = new EmployeePositionDto();

    async ngOnChanges(changes: SimpleChanges) {
        if (changes.selectedEmployeeId.currentValue) {
            await this.onEmployeeChange(this.selectedEmployeeId);
        }
        else if (this.incidentReport.externalName) {
            this.isNotEmployee = true;
        }
    }

    async onEmployeeChange(employeeId: any) {
        this.incidentReport.employeeId = employeeId;

        this.employeesClient.getEmployeePosition(employeeId).subscribe({
            next: (data) => {
                this.employeePosition = data;
            },
            error: () => {
                this.employeePosition.positionId = null;
                this.employeePosition.jobTitleDescription = null;
            },
        });
    }

    onNotEmployeeToggle(checked: boolean) {
        if (checked) {
            this.incidentReport.employeeId = null;
            this.employeePosition.positionId = null;
            this.employeePosition.jobTitleDescription = null;
        } else {
            this.incidentReport.externalName = '';
        }
    }
}
